import {
  EmbeddedCheckout,
  EmbeddedCheckoutProvider,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function StripePayment() {
  const navigate = useNavigate();
  const {
    createPurchaseSessionError,
    createPurchaseSessionLoading,
    createPurchaseSessionSuccess,
    purchaseSession,
  } = useSelector((state) => state.PaymentPurchaseReducer);
  const {
    publishableKey,
    getPublishableKeySuccess,
    getPublishableKeyLoading,
    getPublishableKeyError,
  } = useSelector((state) => state.PaymentPurchaseReducer);
  const [stripePromise, setStripePromise] = useState(null);
  useEffect(() => {
    if (publishableKey) {
      setStripePromise(loadStripe(publishableKey));
    }
  }, [publishableKey]);

  console.log(stripePromise, purchaseSession);
  return (
    <div className="h-full w-full bg-[white] absolute top-0 left-0  z-[100] flex items-center justify-center hideScrollBar">
      <div className="max-h-[95vh] h-fit overflow-y-scroll w-full hideScrollBar  ">
        <div className="flex-1">
          {purchaseSession?.client_secret && stripePromise && (
            <EmbeddedCheckoutProvider
              stripe={stripePromise}
              options={{
                clientSecret: purchaseSession?.client_secret,
              }}
            >
              <EmbeddedCheckout />
            </EmbeddedCheckoutProvider>
          )}
        </div>
      </div>
    </div>
  );
}

export default StripePayment;
